export enum JWTTokenValidation {
  Valid = 'valid',
  NotFound = 'NotFound',
  Expired = 'Expired'
}
